import styled from '@emotion/styled'

export const DragDropContainer = styled.div`
  .uppy-DragDrop--isDragDropSupported {
    border: 2px dashed rgba(0, 0, 0, 0.2);
  }
  .uppy-DragDrop-label {
    color: rgba(25, 31, 37, 0.6);
    font-size: 0.75rem;
    margin-top: 48px;
  }
  .uppy-DragDrop-browse {
    color: #0056fe;
  }
  .uppy-c-icon {
    display: none;
  }
`
